import { AutogenModelDriverRating, AutogenRowDriverRating } from "./autogen/AutogenModelDriverRating";

export class ModelDriverRating extends AutogenModelDriverRating<RowDriverRating> {
	constructor() {
		super(RowDriverRating);
	}
}

export class RowDriverRating extends AutogenRowDriverRating {
}